import * as React from "react";
export class Label extends React.Component {
    constructor(props) {
        super(props);
        this.state = { style: {} };
    }
    componentDidMount() {
        this.styleTimer = window.setTimeout(() => {
            const s = ".15s ease-out";
            const style = {
                transition: s,
                WebkitTransition: s,
                MozTransition: s,
                OTransition: s,
                msTransform: s,
            };
            this.setState({ style });
        }, 150);
    }
    componentWillUnmount() {
        window.clearTimeout(this.styleTimer);
    }
    render() {
        return (React.createElement("label", { style: this.state.style, onClick: this.props.onClick }, this.props.text));
    }
}
//# sourceMappingURL=label.js.map